<template>
  <el-dialog :title="title" :visible.sync="localVisible" width="600px" :close-on-click-modal="false" :z-index="9999"
    @close="$emit('update:visible', false)">
    <div class="order-associator-content">
      <!-- 已关联订单员列表 -->
      <div class="already-bound-orderers">
        <div class="orderer-search-section">
          <h5>已关联订单员</h5>
        </div>
        <el-table v-if="alreadyBoundOrderers && alreadyBoundOrderers.length > 0" :data="alreadyBoundOrderers" border
          style="width: 100%" size="small">
          <el-table-column prop="openId" label="订单员ID" min-width="200"></el-table-column>
          <el-table-column prop="createTime" label="关联时间" width="180"></el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-delete" @click="removeOrdererBinding(scope.row)">解除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="no-orderers-tip">暂无关联订单员</div>
      </div>
      <!-- 添加订单员 -->
      <div class="add-orderer-section">
        <h5>添加关联订单员</h5>
        <el-form :model="ordererForm" :rules="rules" ref="ordererFormRef" label-width="100px">
          <el-form-item label="订单员ID" prop="openId">
            <el-input v-model="ordererForm.openId" placeholder="请输入订单员ID" maxlength="50"></el-input>
          </el-form-item>
        </el-form>
        <div class="add-orderer-btn-container">
          <el-button type="text" icon="el-icon-plus" @click="addOrdererBinding">添加</el-button>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="text" icon="el-icon-close" @click="$emit('update:visible', false)">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { bindOrderer, getOrdererList, removeOrdererBinding } from '@/api/salesCloud/businessEntity/businessEntity';
export default {
  name: 'OrderAssociator',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '关联订单员'
    },
    businessEntityId: {
      type: [String, Number, null],
      default: null
    }
  },
  data() {
    return {
      // 本地可见性状态
      localVisible: this.visible,
      // 已关联订单员列表
      alreadyBoundOrderers: [],
      // 订单员表单
      ordererForm: {
        openId: ''
      },
      // 表单验证规则
      rules: {
        openId: [
          { required: true, message: '请输入订单员ID', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        this.localVisible = newVal;
        if (newVal && this.businessEntityId) {
          this.loadAlreadyBoundOrderers();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 加载已关联订单员
    loadAlreadyBoundOrderers() {
      if (!this.businessEntityId) {
        this.alreadyBoundOrderers = [];
        return;
      }
      getOrdererList({
        businessEntityId: this.businessEntityId
      }).then(res => {
        if (res.code == 200) {
          this.alreadyBoundOrderers = JSON.parse(res.data).rows || [];
        }
      });
    },
    // 添加关联订单员
    addOrdererBinding() {
      if (!this.businessEntityId) {
        this.$message.error('经营主体ID不能为空');
        return;
      }
      this.$refs.ordererFormRef.validate((valid) => {
        if (valid) {
          // 调用API添加关联订单员
          bindOrderer({
            businessEntityId: this.businessEntityId,
            openId: this.ordererForm.openId
          }).then(() => {
            // 关联成功后，刷新已关联订单员列表
            this.loadAlreadyBoundOrderers();
            this.$message.success('添加关联成功');
            this.ordererForm.openId = '';
          });
        } else {
          return false;
        }
      });
    },
    // 解除订单员关联
    removeOrdererBinding(orderer) {
      this.$confirm(`确定要解除与订单员"${orderer.openId}"的关联吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 调用API解除关联
          removeOrdererBinding(orderer).then(() => {
            // 解除成功后，刷新已关联订单员列表
            this.loadAlreadyBoundOrderers();
            this.$message.success('解除关联成功');
          });
        })
        .catch(() => {
          this.$message.info('已取消解除关联');
        });
    }
  }
};
</script>
<style scoped>
.order-associator-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.already-bound-orderers {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.orderer-search-section h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.no-orderers-tip {
  padding: 20px;
  color: #909399;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px dashed #ebeef5;
  border-radius: 4px;
}
.add-orderer-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.add-orderer-section h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.add-orderer-btn-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}
.dialog-footer {
  text-align: right;
}
</style>